module.exports = __webpack_public_path__ + "static/media/calendar-history-white.5408718a.svg";